<div class="product-info-root">
  <header>
    <div>
      <h1>{{ data.productData.name }}</h1>
      <button id="close-dialog-icon" (click)="onDialogClose()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <h2>{{ descriptionLabel | transloco }}</h2>
  </header>
  <nav>
    <span
      *ngFor="let tabLabel of tabLabels; let i = index"
      [ngClass]="{ active: activeTabIndex === i }"
      (click)="activeTabIndex = i"
    >
      {{ tabLabel | transloco }}
    </span>
  </nav>
  <div class="content">
    <ng-container *ngIf="activeTabIndex === 0">
      <app-product-overview
        [data]="data.productData"
        (editProduct)="goToProductEdit()"
      ></app-product-overview>
    </ng-container>
    <ng-container *ngIf="activeTabIndex === 1">
      <app-product-rewards
        [product]="data.productData"
        (addReward)="this.onDialogClose()"
        (deleteReward)="openDeleteReward($event)"
      ></app-product-rewards>
    </ng-container>
  </div>
</div>
